import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nudges',
  templateUrl: './nudges.component.html',
  styleUrls: ['./nudges.component.scss']
})
export class NudgesComponent {
  isShownWebModal = true;
  @Input() nudge_data;

  constructor() {
    // No Code
  }

  hideModal(): void {
    this.isShownWebModal = false;
  }

  onHidden(): void {
    this.isShownWebModal = false;
  }
}
